
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-of-seek-sophie/[id]",
      function () {
        return require("private-next-pages/best-of-seek-sophie/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-of-seek-sophie/[id]"])
      });
    }
  